import { render, staticRenderFns } from "./AiChatModal.vue?vue&type=template&id=7045b1d9&scoped=true&"
import script from "./AiChatModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiChatModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiChatModal.vue?vue&type=style&index=0&id=7045b1d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7045b1d9",
  null
  
)

export default component.exports